import { Component } from '@verndale/core';
import modalTemplate from '../../html/components/modal.hbs';
import Modal from './modal';

class AudioCard extends Component {
  setupDefaults() {
    this.dom = {
      $modalButton: this.el.querySelector<HTMLElement>('.audio-card__transcript-button')
    };
  }

  addListeners() {
    (this.dom.$modalButton as HTMLElement)?.addEventListener(
      'click',
      this.handleModalButtonClick.bind(this)
    );
  }

  handleModalButtonClick(e: Event) {
    const target = e.target as HTMLElement;
    const modal = document.querySelector(`[data-modal-id="${target.dataset.modalTrigger}"`);

    if (modal) {
      (modal as HTMLDialogElement)?.showModal();
    } else {
      const compiledModal = modalTemplate(
        {
          content: target.dataset.modalContent,
          modalId: target.dataset.modalTrigger
        },
        { viewMode: 'docs' }
      );

      document.body.insertAdjacentHTML('beforeend', compiledModal);

      const m = document.querySelector(`[data-modal-id="${target.dataset.modalTrigger}"`);
      if (m) {
        new Modal(m as HTMLElement);
        (m as HTMLDialogElement)?.showModal();
      }
    }
  }
}

export default AudioCard;
